// @ts-nocheck

import { combineReducers } from 'redux'

import {
  app,
  enrolledPrograms,
  introspect,
  message,
  priorPrograms,
  school,
  serviceProvider,
  surveyData,
  uiState,
} from './app.reducer'
import auth from './auth.reducer'
import parents from './dashboards.reducer'
import device from './device.reducer'
import enrollmentSummary from './enrollment.summary.reducer'
import header from './header.reducer'
import masterData from './masterData.reducer'
import metadata from './metadata.reducer'
import { payment, transaction } from './payment.reducer'
import user from './user.reducer'

export default combineReducers({
  device,
  auth,
  header,
  app,
  enrollmentSummary,
  message,
  school,
  masterData,
  metadata,
  user,
  uiState,
  payment,
  transaction,
  introspect,
  parents,
  serviceProvider,
  enrolledPrograms,
  priorPrograms,
  surveyData,
})
